import React from 'react';
import styles from './TransparentButton.module.scss';

interface ITransparentButtonProps {
    children: React.JSX.Element | string;
    onClick: () => void;
    outline?: boolean;
    disabled?: boolean;
    noMargin?: boolean;
    mini?: boolean;
}

export const TransparentButton = ({
    children,
    onClick,
    outline,
    disabled = false,
    noMargin,
    mini,
}: ITransparentButtonProps) => {
    const buttonClasses = [styles.transparentButton];
    if (outline) buttonClasses.push(styles.outline);
    if (noMargin) buttonClasses.push(styles.noMargin);
    if (disabled) buttonClasses.push(styles.disabled);
    if (mini) buttonClasses.push(styles.mini);
    return (
        <div
            onClick={() => {
                if (!disabled) onClick();
            }}
            className={buttonClasses.join(' ')}
        >
            {children}
        </div>
    );
};
